import { withInstall } from "../utils/index.mjs";
import _CellGroup from "./CellGroup.mjs";
const CellGroup = withInstall(_CellGroup);
var stdin_default = CellGroup;
import { cellGroupProps } from "./CellGroup.mjs";
export {
  CellGroup,
  cellGroupProps,
  stdin_default as default
};
